import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Program, ProgramList } from 'library/models/programs';

interface ProgramListState {
  list: ProgramList[];
  status: 'idle' | 'loading';
  page: number;
  hasNext: boolean;
  search: string;
  tags: number[];
}

const initialState: ProgramListState = {
  list: [],
  status: 'idle',
  page: 1,
  hasNext: true,
  search: '',
  tags: [],
};

export const programList = createSlice({
  name: 'programs/programs',
  initialState,
  reducers: {
    reset: (state: ProgramListState) => {
      state.list = [];
      state.page = 1;
      state.hasNext = true;
      state.status = 'idle';
    },

    setSearch: (state: ProgramListState, action: PayloadAction<string>) => {
      state.search = action.payload;
    },

    setStatus: (state: ProgramListState, action: PayloadAction<'idle' | 'loading'>) => {
      state.status = action.payload;
    },
    setPage: (state: ProgramListState, action: PayloadAction<number>) => {
      state.page = action.payload;
    },

    updateProgram: (state: ProgramListState, action: PayloadAction<Program>) => {
      const program = action.payload as ProgramList & Program;
      const programs = [...state.list];
      const idx = programs.findIndex((program) => program.pk === action.payload.pk);
      programs[idx] = program;
      state.list = [...programs];
    },
    addProgram: (state: ProgramListState, action: PayloadAction<Program | ProgramList>) => {
      const programs = [...state.list];
      const idx = programs.findIndex((program) => program.pk === action.payload.pk);
      if (idx === -1) {
        programs.unshift(action.payload as ProgramList);
      } else {
        programs.splice(idx, 1, action.payload as ProgramList);
      }
      state.list = [...programs];
    },
    removeProgram: (state: ProgramListState, action: PayloadAction<number | string>) => {
      const programs = [...state.list];
      const idx = programs.findIndex((program) => program.pk === action.payload);
      if (idx !== -1) {
        programs.splice(idx, 1);
      }
      state.list = [...programs];
    },
  },
});

export * as programListSelectors from './selectors';
